<!--
 * @Author: M.D.
 * @Date: 2019-12-18 10:50:08
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="message bShadow-5">
    <el-tabs @tab-click="tabClick" v-model="curTabName" class="ui-tabs ui-custom-s">
      <el-tab-pane name="系统通知" class="my-msg">
        <span slot="label" class="lb-txt">我的消息</span>
        <!-- <ui-list :optionName="optionName" :showStatus="true" :dataList="messageList" :detailType="0"></ui-list> -->
      </el-tab-pane>
      <el-tab-pane name="订单消息" class="or-inf">
        <span slot="label" class="lb-txt">订单消息</span>
      </el-tab-pane>
      <ui-list :optionName="optionName" :showStatus="true"  :detailType="0"></ui-list>
    </el-tabs>
    <!-- 分页 -->
    <!-- <div class="msg-pagination-w">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :page-size="paginationValue.pageSize"
        :total="paginationValue.total">
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
import UiList from '@/components/ui-list'
// import API from '@/api/usr-api'
export default {
  name: 'message',
  props: {

  },
  data () {
    return {
      optionName: '系统通知',
      paginationValue: {
        total: 0,
        pageSize: 4
      },
      queryParam: {
        currentPage: 1,
        pageSize: 4,
        way: '系统通知'
      },
      curTabName: '系统通知',
      messageList: []
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    // async getMessageList () {
    //   const res = await API.getMessageList(this.queryParam)
    //   this.paginationValue.total = parseInt(res.data.result.total)
    //   this.messageList = res.data.result.records
    // },
    tabClick (option) {
      console.log(option)
      this.optionName = option.name
      // this.queryParam.way = option.name
      // this.queryParam.currentPage = 1
      // this.getMessageList()
    }
    // pageChange (currentPage) {
    //   this.queryParam.currentPage = currentPage
    //   this.getMessageList()
    // }
  },
  components: {
    UiList
  }
}
</script>

<style lang="stylus">
.message
  height 666px
  box-sizing border-box
  background-color #ffffff
  position relative
  .my-msg, .or-inf
    .item
      height 110px
      display flex
      box-sizing border-box
      padding 10px 40px 10px 0
      .status
        text-align center
        color black
        flex 0 0 40px
        font-size 30px
        color #666666
      .content
        flex 1 1 auto
        border-bottom 1px solid #dddddd
        .title-date
          flex-ltr-parent()
          .t
            height 40px
            line-height 34px
            color #333333
            font-size 16px
          .d
            height 28px
            line-height 28px
            font-size 14px
            color #999999
        .brief
          height 40px
          line-height 40px
          font-size 14px
          color #8C8C8C
          ellipsis2(1)
  .msg-pagination-w
    position absolute
    right 30px
    bottom 40px
</style>
